export default "__VITE_ASSET__DmTZWct3__"